export default __webpack_public_path__ + "static/media/dst.776748eb.png";